import React from "react";
import "../public css/Pricing.css";
import {
  FaBolt,
  FaChartBar,
  FaBoxOpen,
  FaShieldAlt,
} from "react-icons/fa";
const Pricing = () => {
  const plans = [
    {
      name: "Starter",
      price: "₹499",
      description: "Perfect for small businesses getting started.",
      features: [
        "Up to 500 invoices",
        "Customer management",
        "Basic reports",
        "Email support",
      ],
      popular: false,
    },
    {
      name: "Business",
      price: "₹999",
      description: "Everything you need to manage your growing business.",
      features: [
        "Unlimited invoices",
        "Customer management",
        "Advanced reports",
        "Inventory management",
        "Priority support",
      ],
      popular: true,
    },
    {
      name: "Enterprise",
      price: "₹1,999",
      description: "Powerful billing tools for large businesses.",
      features: [
        "Unlimited invoices",
        "Advanced inventory",
        "Detailed analytics",
        "Multiple users",
        "Dedicated support",
      ],
      popular: false,
    },
  ];

  return (
    <div className="pricing-page">

      <section className="pricing-hero">

  <div className="pricing-overlay"></div>

  <div className="pricing-hero-content">

    <span className="pricing-label">
      SIMPLE & POWERFUL BILLING SOFTWARE
    </span>

    <h1>
      Smart billing
      <span> for growing businesses.</span>
    </h1>

    <p>
      Manage invoices, customers, payments, inventory and
      business reports with simple and powerful billing
      software designed for your business.
    </p>

    <div className="pricing-hero-buttons">

      {/* <button className="pricing-primary-btn">
        Start Free Trial
      </button> */}
{/* 
      <button className="pricing-secondary-btn">
        Explore Billing
      </button> */}

    </div>

  </div>

</section>



     <section className="pricing-section">

  <div className="pricing-container">

    <div className="pricing-heading">
      <span>SMART BILLING, SIMPLE BUSINESS</span>

      {/* <h2>
        Choose your plan
      </h2> */}

  
    </div>


    <div className="pricing-form-wrapper">

      <form className="pricing-form">

      




        <div className="form-section-title form-space">

      

          <div>
            <h3>Business details</h3>

            <p>
              Tell us a little about your business.
            </p>
          </div>

        </div>


        <div className="form-grid">

          <div className="form-group">

            <label>
               Name
            </label>

            <input
              type="text"
              placeholder="Enter your name"
              required
            />

          </div>


          <div className="form-group">

            <label>
              Email
            </label>

            <input
              type="text"
              placeholder="Enter your email"
              required
            />

          </div>


          <div className="form-group">

            <label>
              Mobile
            </label>

            <input
              type="number"
              placeholder="Enter your mobile number"
              required
            />

          </div>


          <div className="form-group">

            <label>
              Address
            </label>

            <input
              type="tel"
              placeholder="Enter your address"
              required
            />

          </div>

        </div>


        <div className="form-grid">

          <div className="form-group">

            <label>
              Business Type
            </label>

            <select required>

              <option value="">
                Select business type
              </option>

              <option value="retail">
                Retail
              </option>

              <option value="wholesale">
                service
              </option>

            </select>

          </div>
          
          <div className="form-group">

            <label>
              Business Name
            </label>

            <input
              type="tel"
              placeholder="Enter your address"
              required
            />

          </div>
 <div className="form-group">

            <label>
              Business Category
            </label>

            <input
              type="tel"
              placeholder="Enter your address"
              required
            />

          </div>
          {/* <div className="form-group">

            <label>
              Number of Users
            </label>

            <select>

              <option value="1">
                1 User
              </option>

              <option value="2-5">
                2 - 5 Users
              </option>

              <option value="6-10">
                6 - 10 Users
              </option>

              <option value="10+">
                10+ Users
              </option>

            </select>

          </div> */}

        </div>


      
        <div className="form-group">

          <label>
            Additional Message
          </label>
{/* 
          <textarea
            rows="5"
            placeholder="Tell us anything else about your requirements..."
          ></textarea> */}
          <textarea
  rows="5"
  style={{ resize: "none" }}
  placeholder="Tell us anything else about your requirements..."
></textarea>

        </div>


{/*        
        <div className="form-check-row">

          <input
            type="checkbox"
            id="terms"
            required
          />

          <label htmlFor="terms">
            I agree to the Dectwinn terms and conditions.
          </label>


        </div>
 */}

        <button
          type="submit"
          className="pricing-submit-btn"
        >
          Submit
        </button>

    

      </form>

    </div>

  </div>

</section>


    
      <section className="pricing-cta">

        <div className="pricing-cta-content">

          <span>READY TO GET STARTED?</span>

          <h2>
            Make billing simple
            <br />
            for your business.
          </h2>

          <p>
            Start managing your invoices, customers and
            business payments with Dectwinn.
          </p>

          {/* <button>
            Start Free Trial
          </button> */}

        </div>

      </section>
      {/* <section className="pricing-benefits">
  <div className="pricing-container">

    <div className="pricing-heading">
      <span>WHY DECTWINN</span>

      <h2>
        Everything you need
        <br />
        to run your business.
      </h2>

      <p>
        Powerful billing tools designed to save time,
        reduce manual work and help your business grow.
      </p>
    </div>

    <div className="benefits-grid">

      
      <div className="benefit-card">
        <div className="benefit-icon">
          <FaBolt />
        </div>

        <h3>Fast & Simple</h3>

        <p>
          Create professional invoices and manage your
          billing process in just a few clicks.
        </p>
      </div>


    
      <div className="benefit-card">
        <div className="benefit-icon">
          <FaChartBar />
        </div>

        <h3>Powerful Reports</h3>

        <p>
          Get clear insights into sales, revenue,
          customers and business performance.
        </p>
      </div>


   
      <div className="benefit-card">
        <div className="benefit-icon">
          <FaBoxOpen />
        </div>

        <h3>Inventory Control</h3>

        <p>
          Track products, stock levels and inventory
          without complicated spreadsheets.
        </p>
      </div>


      <div className="benefit-card">
        <div className="benefit-icon">
          <FaShieldAlt />
        </div>

        <h3>Secure Data</h3>

        <p>
          Keep your business and billing information
          protected with secure technology.
        </p>
      </div>

    </div>
  </div>
</section> */}
      

    </div>
  );
};

export default Pricing;
